import styled from "styled-components";

// Components
import { Heading1, Paragraph } from "../components/typography";

// Containers
import LoginForm from "../containers/forms/login/Login.from";

// Styles
import { media } from "../styles/media";

// Breaks the title after "Welcome to" on phones (two lines), stays inline on
// larger screens.
const TitleBreak = styled.span`
  ${media.maxMobile`
    display: block;
  `}
`;

const Login = () => {
  return (
    <>
      <Heading1 style={{ margin: "40px 0 8px 0", fontSize: 32 }}>
        Welcome to <TitleBreak>TruckFix ERP</TitleBreak>
      </Heading1>
      <Paragraph
        style={{ margin: "0 0 40px 0", color: "#8E8E8E", fontSize: 14 }}
      >
        Sign in to manage your shops and services.
      </Paragraph>
      <LoginForm />
    </>
  );
};

export default Login;
